import React from 'react';

import { EditIcon } from '@vlabs/icons';
import { routes } from '@vlabs/shared/navigation/routes';
import { Control } from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { generatePath, useHistory } from 'react-router-dom';

export function EditNotificationCell({ value = {} }) {
  const history = useHistory();

  const notificationId = value?.id;
  const type = value?.type?.value;
  const eventType = type ?? 'events';

  return (
    <Control.IconButton
      data-testid="notificationEditButton"
      icon={<EditIcon />}
      kind="secondary"
      onClick={() => history.push(generatePath(routes.notifications.read, { notificationId }), { eventType })}
      variant="flat"
    />
  );
}

EditNotificationCell.propTypes = {
  value: PropTypes.object,
};
